import { useState } from "react";
import { Button, Modal, showToast } from "@xpense/ui";
import { api, Transaction } from "../api/client";

interface ConfirmDeleteModalProps {
  transaction: Transaction;
  open: boolean;
  onClose: () => void;
  onDeleted: (id: string) => void;
}

export default function ConfirmDeleteModal({
  transaction,
  open,
  onClose,
  onDeleted,
}: ConfirmDeleteModalProps) {
  const [deleting, setDeleting] = useState(false);

  const formatINR = (amount: number) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(
      Math.abs(amount)
    );

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await api.delete(`/api/v1/transactions/${transaction.id}`);
      showToast("Transaction deleted", "success");
      onDeleted(transaction.id);
    } catch (err) {
      showToast(err instanceof Error ? err.message : "Failed to delete transaction", "error");
      setDeleting(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Delete Transaction?"
      footer={
        <>
          <Button variant="secondary" size="sm" onClick={onClose} disabled={deleting}>
            Cancel
          </Button>
          <Button variant="danger" size="sm" onClick={handleDelete} loading={deleting}>
            Delete
          </Button>
        </>
      }
    >
      <p style={{ margin: 0, color: "var(--xpn-text)", fontSize: 15, lineHeight: 1.5 }}>
        Are you sure you want to delete this transaction?
      </p>
      <div
        style={{
          marginTop: "var(--xpn-space-md)",
          padding: "var(--xpn-space-md)",
          background: "var(--xpn-surface-2)",
          borderRadius: "var(--xpn-radius-md)",
          fontSize: 14,
          color: "var(--xpn-text-muted)",
        }}
      >
        <strong style={{ color: "var(--xpn-text)" }}>
          {transaction.merchant || "Unresolved merchant"}
        </strong>
        {" · "}
        {formatINR(transaction.amount)}
      </div>
      <p
        style={{
          marginTop: "var(--xpn-space-md)",
          marginBottom: 0,
          fontSize: 13,
          color: "var(--xpn-text-muted)",
        }}
      >
        This action will soft-delete the transaction. It can be recovered later.
      </p>
    </Modal>
  );
}
